import { useEffect, useState } from 'react';
import {
  COMMON_EVENT_NAMES,
  logEvent,
  ModalTypes,
  ProductAreas,
} from 'utils/events';

type ExtraProperties = Record<string, unknown>;

const logCancelEvent = ({
  modalType,
  openDuration,
  productArea,
  extraProperties,
}: {
  openDuration?: number;
  modalType: ModalTypes;
  productArea: ProductAreas;
  extraProperties?: ExtraProperties;
}) => {
  logEvent(COMMON_EVENT_NAMES.MODAL_DISMISSED, {
    modal_type: modalType,
    open_duration: openDuration,
    product_area: productArea,
    ...extraProperties,
  });
};

const useModalTracking = ({
  isOpen,
  modalType,
  productArea,
  extraProperties,
}: {
  isOpen: boolean;
  modalType: ModalTypes;
  productArea: ProductAreas;
  extraProperties?: ExtraProperties;
}): (() => void) => {
  const [openTime, setOpenTime] = useState<number | null>(null);

  useEffect(() => {
    if (isOpen) {
      setOpenTime(performance.now());
    }
  }, [isOpen]);

  return () => {
    let openDuration;
    if (openTime) {
      openDuration = performance.now() - openTime;
      setOpenTime(null);
    }

    logCancelEvent({ modalType, openDuration, productArea, extraProperties });
  };
};

export default useModalTracking;
